import { render, staticRenderFns } from "./Platen.vue?vue&type=template&id=f101a1a8&scoped=true"
import script from "./Platen.vue?vue&type=script&lang=js"
export * from "./Platen.vue?vue&type=script&lang=js"
import style0 from "./Platen.vue?vue&type=style&index=0&id=f101a1a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f101a1a8",
  null
  
)

export default component.exports